module.exports = __webpack_public_path__ + "img/message-push.33f3735d.svg";